import { render } from "./LeadsAssignDialog.vue?vue&type=template&id=33d85d3d"
import script from "./LeadsAssignDialog.vue?vue&type=script&lang=js"
export * from "./LeadsAssignDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__